// Wait for the DOM to fully load
document.addEventListener("DOMContentLoaded", function () {
  // Get all elements with the class "collection-cta__url"
  const collectionUrls = document.querySelectorAll(".collection-cta__url");

  // Loop through all elements and add a click event listener
  collectionUrls.forEach(function (element) {
    element.addEventListener("click", function (event) {
      // Check if the href attribute is not defined or empty
      if (!this.getAttribute("href") || this.getAttribute("href") === "") {
        // Prevent default action
        event.preventDefault();

        // Find the closest parent container to the clicked element
        const closestContainer = this.closest(".content.subcollection");

        // Find the dialog within the closest parent container
        const dialog = closestContainer ? closestContainer.querySelector(".dialog-focus-panel") : null;

        // Check if the dialog element was found and is actually a dialog
        if (dialog && dialog.tagName.toLowerCase() === "dialog") {
          // Show the dialog
          dialog.showModal();
        }
      }
    });
  });
});
